import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Dashboard.css';

function Dashboard() {
  const { user, empresaAtual } = useAuth();

  return (
    <div className="dashboard-page">
      <h1>Bem-vindo{user?.nome ? `, ${user.nome}` : ''}!</h1>
      <p className="dashboard-subtitle">Painel do NFSeApp</p>

      <div className="dashboard-card">
        <h2>Empresa ativa</h2>
        {empresaAtual ? (
          <ul className="dashboard-empresa-info">
            <li><strong>Razão social:</strong> {empresaAtual.razaosocial}</li>
            <li><strong>Fantasia:</strong> {empresaAtual.fantasia || '-'}</li>
          </ul>
        ) : (
          <p>Nenhuma empresa ativa selecionada.</p>
        )}
      </div>

      <div className="dashboard-grid">
        <Link to="/nfse/emissor/nova" className="dashboard-widget" style={{ textDecoration: 'none' }}>
          <i className="pi pi-file-edit" />
          <h3>Emitir NFS-e</h3>
          <p>Gere uma nova nota fiscal de serviço eletrônica.</p>
        </Link>
        <Link to="/nfse/emissor" className="dashboard-widget" style={{ textDecoration: 'none' }}>
          <i className="pi pi-check-circle" />
          <h3>NFS-e Emitidas</h3>
          <p>Consulte as notas já emitidas pela sua empresa.</p>
        </Link>
        <Link to="/nfse/tomadas" className="dashboard-widget" style={{ textDecoration: 'none' }}>
          <i className="pi pi-inbox" />
          <h3>NFS-e Tomadas</h3>
          <p>Notas de serviços tomados por sua empresa.</p>
        </Link>
        <Link to="/bi" className="dashboard-widget" style={{ textDecoration: 'none' }}>
          <i className="pi pi-chart-bar" />
          <h3>BI</h3>
          <p>Indicadores e widgets do painel analítico.</p>
        </Link>
      </div>
    </div>
  );
}

export default Dashboard;
